
import { Volunteer } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { volunteersActions } from "./volunteer.actions";

export interface VolunteerState {
    volunteers: Volunteer.VolunteerDto[];
    nb: number;
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: VolunteerState = {
    volunteers: [],
    nb: 0,
    loading: true
}

export const volunteersReducer = createReducer(
    initialeState,
    on(
        volunteersActions["[Volunteer-API]LoadVolunteer"], state => ({
            ...state,
            loading: true
        })
    ),
    on(
        volunteersActions["[Volunteer-API]LoadSuccess"], (state, res) => ({
            ...state,
            loading: false,
            volunteers: res.data?.volunteers ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        volunteersActions["[Volunteer-API]LoadFailed"], (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        }))
)